// src/components/StatsSection.js
import React from 'react';
import Counter from './Counter';
import './StatsSection.css';

const StatsSection = () => {
  const statsData = [
    { value: 150, suffix: '+', label: 'Projets réalisés' },
    { value: 50, suffix: '+', label: 'Clients satisfaits' },
    { value: 5, suffix: '+', label: 'Années d\'expérience' },
    { value: 99, suffix: '%', label: 'Taux de satisfaction' }
  ];

  return (
    <section className="stats-section">
      <div className="container">
        <div className="stats-grid">
          {statsData.map((stat, index) => (
            <Counter
              key={index}
              end={stat.value}
              suffix={stat.suffix}
              label={stat.label}
              duration={1500} // 1.5 secondes pour l'animation
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;